import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "result"]
  static values = { url: String }

  async load() {
    this.buttonTarget.disabled = true
    this.resultTarget.textContent = "Analisando pedidos..."

    try {
      const form = this.element
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: new FormData(form),
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
          "Accept": "application/json"
        }
      })
      const data = await response.json()
      if (!response.ok) throw new Error(data.errors?.join("; ") || "Não foi possível calcular a prévia.")

      const suffix = data.sampled ? " (amostra dos 500 pedidos mais recentes)" : ""
      this.resultTarget.textContent = `${data.matching_orders} pedidos atendem à regra; ${data.without_vehicle} sem veículo por esta regra; ${data.combined_without_vehicle} sem veículo ao combinar as regras ativas${suffix}.`
    } catch (error) {
      this.resultTarget.textContent = error.message
    } finally {
      this.buttonTarget.disabled = false
    }
  }
}
